import reducer from "./reducer";
export { default as Receipts } from "./components/index";
export { default as receiptsReducerName } from "./constants";
export default reducer;
